import { render } from "./BerandaView.vue?vue&type=template&id=4b10150e&lang=true"
import script from "./BerandaView.vue?vue&type=script&lang=js"
export * from "./BerandaView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__